import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Tabs } from 'antd';
import { Scroll } from 'components/UI';
import { VelocityComponent, VelocityTransitionGroup } from 'velocity-react';
import { attributeClose, attributeHide } from 'theme/icon';
import styles from './styles.scss';
import AttributeComponent from '../../components';
import DetailsComponent from '../index';
import Select from '../../control/select';
import validateMap from '../../control/validate';

const { TabPane } = Tabs;

const MultipleChoiceDetails = props => {
  const [detailsIndex, setDetailsIndex] = useState(null);
  const [options, setOptions] = useState(
    (props.item.options || []).filter(el => (props.item.value || []).find(val => +val === el.id)),
  );
  const [tabId, _setTabId] = useState(options.length > 0 ? options[0].id : null);
  const tabIdRef = React.useRef(tabId);
  const setTabId = data => {
    tabIdRef.current = data;
    _setTabId(data);
  };

  useEffect(() => {
    setOptions((props.item.options || []).filter(el => (props.item.value || []).find(val => +val === el.id)));
  }, [props.item.value]);

  const select = (
    <div className={styles.selectValue}>
      <Select
        options={props.item.options}
        onChange={val => {
          setOptions(val);
          props.onChange(val.map(el => el.id));
        }}
        value={options}
      />
    </div>
  );

  const validate = useRef(values =>
    validateMap[values.typeId]({
      ...values,
      value: values && values.value && values.value[tabIdRef.current] ? values.value[tabIdRef.current].value : null,
    }),
  ).current;

  const Icon = detailsIndex !== null ? attributeClose : attributeHide;
  return (
    <VelocityComponent
      animation={{
        height: detailsIndex !== null ? 289 : 590,
      }}
      duration={200}
    >
      <div className={styles.multipleChoice}>
        <VelocityComponent
          animation={{
            translateX: detailsIndex !== null ? '10000px' : 0,
          }}
          duration={200}
        >
          <div style={{ position: 'absolute', width: '100%' }}>
            <Tabs
              direction="rlt"
              activeKey={tabId ? tabId.toString() : null}
              onTabClick={id => setTabId(id)}
              tabBarExtraContent={{ left: select }}
              tabBarStyle={{
                color: '#999999',
                height: 42,
                marginBottom: 'unset',
                marginTop: 34,
              }}
              style={{
                overflow: 'visible',
              }}
              tabBarGutter={20}
            >
              {(options || []).map(item => (
                <TabPane tab={item.name} key={item.id.toString()}>
                  <Scroll universal style={{ width: '100%' }} autoHeightMax={520}>
                    <div className={styles.list}>
                      {props.item.children.map((attribute, index) => {
                        const isDetailsOpen = detailsIndex === index;
                        return (
                          <Field
                            key={`${attribute.id}_multiple_${item.id}`}
                            name={`attributes[${props.index}].children[${index}]`}
                            width={318}
                            isEditAccess={props.isEditAccess}
                            component={AttributeComponent}
                            validate={validate}
                            onEdit={() => {
                              if (attribute.typeId === 3) {
                                setDetailsIndex(index);
                              }
                            }}
                            isDetailsOpen={isDetailsOpen}
                            multipleChoiceId={tabId}
                            default={props.default}
                          />
                        );
                      })}
                    </div>
                  </Scroll>
                </TabPane>
              ))}
            </Tabs>
          </div>
        </VelocityComponent>
        <VelocityTransitionGroup
          enter={{
            animation: {
              translateX: [0, '100vw'],
            },
            duration: 200,
          }}
          leave={{
            animation: {
              translateX: ['100vw', 0],
            },
            duration: 200,
          }}
          duration={200}
        >
          {detailsIndex != null && (
            <Field
              name={`attributes[${props.index}].children[${detailsIndex}]`}
              isEditAccess={props.default.isEditAccess}
              component={DetailsComponent}
              isDetailsOpen={detailsIndex}
              multipleChoiceId={tabId}
              isDelay={false}
              default={{
                ...props.default,
                onBack: () => {
                  setDetailsIndex(null);
                },
              }}
            />
          )}
        </VelocityTransitionGroup>
        <span className={styles.close} onClick={props.onClose}>
          <Icon alt="" />
        </span>
      </div>
    </VelocityComponent>
  );
};

MultipleChoiceDetails.propTypes = {
  index: PropTypes.number.isRequired,
  isEditAccess: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  default: PropTypes.objectOf(PropTypes.any).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default MultipleChoiceDetails;
